import TransferSelectAllButton from './TransferSelectAllButton.js'
import {transferIDListSelector} from './transferListFunctions.js'
import Row from './Row.js'
import EmptyList from './EmptyList.js'
import {useSelector} from '../../store.js'

export default function Table() {
  const transferIDList = useSelector(transferIDListSelector)

  return (
    <table className="table table--zebra-list table--product-list">
      <thead>
        <tr className="table__tr">
          <th className="table__th table__th--sm v-align-middle no-border table__th--order-checkbox">
            <TransferSelectAllButton />
          </th>
          <th className="table__th table__th--sm th-width-25 v-align-middle no-border">
            <span className="fs-00 lh-md">Transfer ID</span>
          </th>
          <th className="table__th table__th--sm th-width-15 v-align-middle no-border">
            <span className="fs-00 lh-md">SKUs</span>
          </th>
          <th className="table__th table__th--sm th-width-20 v-align-middle no-border">
            <span className="fs-00 lh-md">Sending Warehouse</span>
          </th>
          <th className="table__th table__th--sm th-width-20 v-align-middle no-border">
            <span className="fs-00 lh-md">Receiving Warehouse</span>
          </th>
          <th className="table__th table__th--sm th-width-20 v-align-middle no-border">
            <span className="fs-00 lh-md">Date Created</span>
          </th>
          <th className="table__th table__th--sm v-align-middle no-border" />
        </tr>
      </thead>
      <tbody className="table__tbody--full-border">
        {transferIDList.map((transferID) => (
          <Row key={transferID} transferID={transferID} />
        ))}
        {transferIDList.length === 0 && <EmptyList colSpan="6" />}
      </tbody>
    </table>
  )
}
